/* eslint-disable no-unused-vars */
import React from 'react';
import { Route, Link, Redirect, BrowserRouter as Router, Switch } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Toast } from 'react-bootstrap';
import moment from 'moment';

class StoryDetails extends React.Component {
    constructor(props) {
        super();
        const { match } = props;
        this.state = {
            id: match.params.id,
            apiUrl: window.$apiUrl,
            storyDetails: [],
            StoryLayout: [],
            CountryList: [],
            ProjectList: [],
            SchoolList: [],
            ThemeList: [],
            expandImage: 0,
            zoomVal: 100,
            searchVal: "",
            redirect2Search: false,
            alertBox: false
        };
        //sessionStorage[strucKey] = JSON.stringify(data.structure);
        this.expandImage = this.expandImage.bind(this);
        this.Zoom = this.Zoom.bind(this);
        this.like = this.like.bind(this);
        this.liked = this.liked.bind(this);
        this.vote = this.vote.bind(this);
        this.searchTag = this.searchTag.bind(this);
        this.goBack = this.goBack.bind(this);
        this.toggleAlertBox = this.toggleAlertBox.bind(this);
    }

    goBack() {
        this.props.history.goBack();
    }

    toggleAlertBox() {
        this.setState({ alertBox: !this.state.alertBox });
    }

    searchTag(val) {
        var searchVal = this.state.searchVal;
        if (val === 'Country') {
            searchVal = 'Country=' + this.state.CountryList[0].Listing_ID;
        } else if (val === 'School') {
            searchVal = 'School=' + this.state.SchoolList[0].Listing_ID;
        } else if (val === 'Project') {
            searchVal = 'Project=' + this.state.ProjectList[0].Listing_ID;
        }

        this.setState({ redirect2Search: true, searchVal: searchVal });
    }

    like(e, sid) {
        e.target.src = "./images/DetailsLikeClicked.png";
        var likeCount = localStorage.getItem('lcount') ? JSON.parse(localStorage.getItem('lcount')) : [];
        var likeShowCount = localStorage.getItem('lshowcount') ? JSON.parse(localStorage.getItem('lshowcount')) : [];
        fetch(this.state.apiUrl + '/CommonAPI/SubmitLike', {
            method: 'POST',
            headers: {
                'token': process.env.REACT_APP_API_TOKEN,
                'Content-Type': 'application/json; charset=utf-8',
                'access-control-allow-origin': '*'
            },
            body: JSON.stringify(
                {
                    "Story_ID": sid
                }
            )
        })
            .then(res => res.json())
            .then((data) => {
                likeCount.push(sid);
                likeShowCount.push(sid);
                this.setState({ alertBox: true });
                localStorage.setItem('lcount', JSON.stringify(likeCount));
                localStorage.setItem('lshowcount', JSON.stringify(likeShowCount));

            })
            .catch(console.log);
    }

    liked(e, sid) {
        var likedList = JSON.parse(localStorage.getItem('lshowcount'));
        var index = likedList.indexOf(sid);
        //likedList.splice(likedList.indexOf(sid), 1);

        if (e.target.src.includes('heart.png')) {
            e.target.src = "./images/DetailsLikeClicked.png";
            if (index > -1) {
                likedList.splice(index, 1);
            }
            localStorage.setItem('lshowcount', JSON.stringify(likedList));
        } else {
            e.target.src = "./images/heart.png";
            likedList.push(sid);
            localStorage.setItem('lshowcount', JSON.stringify(likedList));
            //this.toggleWarningBox();
        }
    }

    vote(e) {
        e.target.src = "./images/DetailsVoteClicked.png";
        var votecount = localStorage.getItem('vcount') ? JSON.parse(localStorage.getItem('vcount')) : [];
        fetch(this.state.apiUrl + '/CommonAPI/SubmitVote', {
            method: 'POST',
            headers: {
                'token': process.env.REACT_APP_API_TOKEN,
                'Content-Type': 'application/json; charset=utf-8',
                'access-control-allow-origin': '*'
            },
            body: JSON.stringify(
                {
                    "Story_ID": this.state.id
                }
            )
        })
            .then(res => res.json())
            .then((data) => {
                votecount.push(this.state.id);
                this.setState({ alertBox: true });
                localStorage.setItem('vcount', JSON.stringify(votecount));
            })
            .catch(console.log);
    }

    expandImage() {
        var imageSize = this.state.expandImage + 1;
        console.log(imageSize);
        if (imageSize > 1) {
            this.setState({ expandImage: 0 })
        } else {
            this.setState({ expandImage: imageSize })
        }

    }

    Zoom(action) {
        var zoomSize;
        var zoomVal = this.state.zoomVal;
        if (action === 'increase') {
            if (zoomVal <= 180) {
                zoomSize = zoomVal + 20;
                this.setState({ zoomVal: zoomSize })

            }
        } else {
            if (zoomVal >= 40) {
                zoomSize = zoomVal - 20;
                this.setState({ zoomVal: zoomSize })

            }
        }

    }

    Challenge_IsValidVotingPeriod() {
        fetch(this.state.apiUrl + '/ChallengeApi/IsValidVotingPeriod', {
            method: 'POST',
            headers: {
                'token': process.env.REACT_APP_API_TOKEN,
                'Content-Type': 'application/json; charset=utf-8',
                'access-control-allow-origin': '*'
            }
        })
            .then(res => res.json())
            .then((data) => {
                if (data === 'OK') {
                    this.setState({ isVotingPeriod: true });
                } else {
                    this.setState({ isVotingPeriod: false });
                }
            })
            .catch(console.log);
    }

    getCountry(id) {
        fetch(this.state.apiUrl + '/CommonAPI/GetCountry', {
            method: 'POST',
            headers: {
                'token': process.env.REACT_APP_API_TOKEN,
                'Content-Type': 'application/json; charset=utf-8',
                'access-control-allow-origin': '*'
            },
            body: JSON.stringify({
                "ID": id
            })
        })
            .then(res => res.json())
            .then((data) => {
                this.setState({ CountryList: data.ListingDetail });
            })
            .catch(console.log);
    }

    GetProject(id) {
        fetch(this.state.apiUrl + '/CommonAPI/GetProject', {
            method: 'POST',
            headers: {
                'token': process.env.REACT_APP_API_TOKEN,
                'Content-Type': 'application/json; charset=utf-8',
                'access-control-allow-origin': '*'
            },
            body: JSON.stringify({
                "ID": id
            })
        })
            .then(res => res.json())
            .then((data) => {
                this.setState({ ProjectList: data.ListingDetail });
            })
            .catch(console.log);
    }

    GetSchool(id) {
        fetch(this.state.apiUrl + '/CommonAPI/GetSchool', {
            method: 'POST',
            headers: {
                'token': process.env.REACT_APP_API_TOKEN,
                'Content-Type': 'application/json; charset=utf-8',
                'access-control-allow-origin': '*'
            },
            body: JSON.stringify({
                "ID": id
            })
        })
            .then(res => res.json())
            .then((data) => {
                this.setState({ SchoolList: data.ListingDetail });
            })
            .catch(console.log);
    }

    getTheme(id) {
        fetch(this.state.apiUrl + '/CommonAPI/GetTheme', {
            method: 'POST',
            headers: {
                'token': process.env.REACT_APP_API_TOKEN,
                'Content-Type': 'application/json; charset=utf-8',
                'access-control-allow-origin': '*'
            },
            body: JSON.stringify({
                "ID": null,
                "Challenge_ID": id,
                "Start_Index": 1,
                "Max_Rows": 1
            })
        })
            .then(res => res.json())
            .then((data) => {
                this.setState({ ThemeList: data.ListingDetail });
            })
            .catch(console.log);
    }

    getStoryDetails() {
        fetch(this.state.apiUrl + '/StoryAPI/GetStoryDetails', {
            method: 'POST',
            headers: {
                'token': process.env.REACT_APP_API_TOKEN,
                'Content-Type': 'application/json; charset=utf-8',
                'access-control-allow-origin': '*'
            },
            body: JSON.stringify({
                "Story_ID": this.state.id
            })
        })
            .then(res => res.json())
            .then((data) => {

                if (data.Status === 'OK') {
                    this.setState({ storyDetails: data.StoryDetail[0], StoryLayout: JSON.parse(data.StoryDetail[0].Story_Layout) });
                    if (data.StoryDetail[0].Country_ID) {
                        this.getCountry(data.StoryDetail[0].Country_ID);
                    }
                    if (data.StoryDetail[0].Project_ID) {
                        this.GetProject(data.StoryDetail[0].Project_ID);
                    }
                    if (data.StoryDetail[0].School_ID) {
                        this.GetSchool(data.StoryDetail[0].School_ID);
                    }
                    if (data.StoryDetail[0].Challenge_ID) {
                        this.getTheme(data.StoryDetail[0].Challenge_ID);
                    }

                } else {
                    window.alert(data.ErrorMessage);
                }
            })
            .catch(console.log);
    }

    componentDidMount() {
        this.Challenge_IsValidVotingPeriod();
        this.getStoryDetails();
    }

    render() {
        const isExpand = this.state.expandImage === 0 ? '400px' : this.state.expandImage === 1 ? '600px' : '';
        const isBG = this.state.expandImage ? this.state.zoomVal + '% auto' : 'cover';
        const details = this.state.storyDetails;
        const struc_data = this.state.StoryLayout;
        let likeArray = localStorage.getItem('lshowcount') ? localStorage.getItem('lshowcount') : [];
        let voteArray = localStorage.getItem('vcount') ? localStorage.getItem('vcount') : [];
        if (this.state.redirect2Search) {
            return <Redirect to={`/stories?${this.state.searchVal}`} />
        }

        return (
            <div className="StoryDetails">
                <div className="Container-fluid">
                    <div className="row m-0">
                        <div className="col-md-12 p-0 preview-control bg-dark">
                            <div className="position-relative" style={{ width: '100%', 'height': isExpand, 'backgroundImage': 'url(' + encodeURI(details.Story_Image) + ')', 'backgroundRepeat': 'no-repeat', 'backgroundPosition': 'center center', 'backgroundSize': isBG, minHeight: '400px', transition: 'all 500ms' }}>
                                {/* <div className="d-flex align-items-center mr-3 bg-light"><img src="images/slice/2.stories/stories/icons/icon-heart.png" className="img-fluid" /></div> */}

                                <div className="position-absolute d-flex justify-content-center align-items-center w-100 mb-2" style={{ bottom: 0 }}>
                                    {/* <button className="btn btn-pink mt-5">Vote!</button><br /> */}

                                    <button onClick={this.expandImage} className="btn btn-secondary mr-2">VIEW IMAGE</button>
                                    {this.state.expandImage === 1 && <div>
                                        <a onClick={() => this.Zoom('increase')} className="mr-2 cursor_pointer"><img src="./images/zoom_in.png" /></a>
                                        <a onClick={() => this.Zoom('decrease')} className="mr-2 cursor_pointer"><img src="./images/zoom_out.png" /></a>
                                    </div>}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="container">
                        <div className="row mt-3">
                            <div className="col-12 col-md-6 d-flex justify-content-start align-items-center">
                                <a onClick={this.goBack} className="cursor_pointer color_113F70"><img src="./images/back.png" className="icons-md" />&nbsp;Back </a>
                            </div>
                            <div className="col-12 col-md-6 py-3 py-md-0 d-flex justify-content-end align-items-center">
                                {!likeArray.includes(details.Story_ID) && <img as="button" onClick={(e) => this.like(e, details.Story_ID)} src="images/DetailsLike.png" className="cursor_pointer mr-2 h-100" />}

                                {likeArray.includes(details.Story_ID) && <img src="images/DetailsLikeClicked.png" onClick={(e) => this.liked(e, details.Story_ID)} data-toggle="tooltip" data-placement="top" title="Like" className="cursor_pointer mr-2 h-100" />}

                                {!voteArray.includes(details.Story_ID) && this.state.isVotingPeriod && <Link to={{ pathname: '/challenge', search: '?cp=true' }} className="pr-2">
                                    <img src="images/DetailsVote.png" as="button" data-toggle="tooltip" data-placement="top" title="Vote" className="cursor_pointer mr-2" />
                                </Link>}

                                {voteArray.includes(details.Story_ID) && this.state.isVotingPeriod && <Link to={{ pathname: '/challenge', search: '?cp=true' }}>
                                    <img src="images/DetailsVoteClicked.png" as="button" data-toggle="tooltip" data-placement="top" title="Vote" className="cursor_pointer mr-2" />
                                </Link>}
                                <div className="pl-3" style={{borderLeft:'1px solid #CCC'}}>
                                    { details.Story_FacebookURL && <a target="_blank" href={details.Story_FacebookURL}><img src="./images/facebook.png" className="icons-social mr-2" /></a> }
                                    { details.Story_InstagramURL && <a target="_blank" href={details.Story_InstagramURL}><img src="./images/instagram.png" className="icons-social" /></a> }
                                </div>

                            </div>
                        </div>
                        <div className="row mt-3 mt-md-5 mb-2">
                            <div className="col-md-12 text-center">
                                <h3 style={{ 'color': '#254D7C', wordBreak: 'break-word' }} className="text-Gotham font-weight-bold">{details.Story_Title}</h3>
                            </div>
                        </div>
                        <div className="row mb-1">
                            <div className="col-md-12 text-center">
                                <p dangerouslySetInnerHTML={{ __html: details.Story_Description }}></p>
                            </div>
                        </div>
                        <div className="row mb-2">
                            <div className="col-md-12 text-center text-Gotham" style={{ 'font-size': '14px' }}>
                                Leader Name: {details.Contact_Name}
                            </div>
                        </div>
                        <div className="row mb-3">
                            <div className="col-md-12 text-center text-Gotham" style={{ 'font-size': '14px' }}>
                                {moment(details.Trip_StartDate).format('DD-MM-YYYY')}&nbsp; to &nbsp;{moment(details.Trip_EndDate).format('DD-MM-YYYY')}
                            </div>
                        </div>

                        {/* <div className="row mb-3">
                        <div className="col-md-12 text-center">
                            <h3>Team Lorem Ipsum</h3>
                        </div>
                    </div> */}
                        <div className="row mb-3">
                            <div className="col-md-12 d-md-flex flex-row justify-content-center">
                                {this.state.CountryList && this.state.CountryList.length > 0 && <div onClick={() => this.searchTag('Country')} className="text-light py-1 px-3 storyTag countryTag mr-2 mb-2 text-center">
                                    {this.state.CountryList.length > 0 ? this.state.CountryList[0].Listing_Name : ''}
                                </div>}
                                {this.state.SchoolList && this.state.SchoolList.length > 0 && <div onClick={() => this.searchTag('School')} className="text-light py-1 px-3 storyTag schoolTag mr-2 mb-2 text-center">
                                    {this.state.SchoolList.length > 0 ? this.state.SchoolList[0].Listing_Name : ''}
                                </div>}
                                {this.state.ProjectList && this.state.ProjectList.length > 0 && <div onClick={() => this.searchTag('Project')} className="text-light py-1 px-3 storyTag projectTag mr-2 mb-2 text-center">
                                    {this.state.ProjectList[0].Listing_Name}
                                </div>}
                                {this.state.ThemeList && this.state.ThemeList.length > 0 && <div onClick={() => this.searchTag('Theme')} className="text-light py-1 px-3 storyTag themeTag mr-2 mb-2 text-center">
                                    {this.state.ThemeList.length > 0 ? this.state.ThemeList[0].Listing_Name : ''}
                                </div>}
                            </div>
                        </div>
                    </div>

                    <div className="container">
                        {struc_data.structure &&
                            struc_data.structure.map((list, index) => {
                                return (
                                    <div key={index}>
                                        <div className={list.classname}>
                                            {
                                                list.items.sort((a, b) => a.order > b.order ? 1 : -1).map((item, index2) => {
                                                    return (
                                                        <div key={index2} className={item.classname} style={{ 'padding': '20px ' }}>
                                                            {item.type === 'image' && <div className="d-flex justify-content-center align-items-center"><img src={item.content} className="img-fluid" /></div>}
                                                            {item.type === 'text' && <div dangerouslySetInnerHTML={{ __html: item.content }}></div>}
                                                            {item.type === 'question' && <div><div className="mb-3 font-weight-bold">{item.question}</div><div dangerouslySetInnerHTML={{ __html: item.content }}></div></div>}

                                                        </div>
                                                    )
                                                })
                                            }

                                        </div>
                                        <div className="d-flex justify-content-center">
                                            <div className="divided_line"></div>
                                        </div>
                                    </div>

                                )
                            })
                        }

                    </div>
                </div>
                <Toast className="position-fixed" style={{ top: 0, left: "50%", zIndex: 999 }} onClose={this.toggleAlertBox} show={this.state.alertBox} animation={true} delay={2000} autohide>
                    <Toast.Header>
                        Thanks for your support!
                </Toast.Header>
                    <Toast.Body>
                        <img src="./images/checked.png" className="icons-md" /> You have liked a story!
                </Toast.Body>
                </Toast>
            </div>
        );
    }
}
export default StoryDetails;
